import { NgModule } from '@angular/core';

import { FormatTimeAgoPipe } from './pipes/format-time-ago.pipe';
import { PluralizePipe } from './pipes/pluralize.pipe';
import { SortMatchHighlightsPipe } from './pipes/sort-match-highlights.pipe';
import { TimeZonePipe } from './pipes/time-zone.pipe';
import { UnsafeHtmlPipe } from './pipes/unsafe-html.pipe';

const PIPES = [
  PluralizePipe,
  SortMatchHighlightsPipe,
  UnsafeHtmlPipe,
];

@NgModule({
  // Standalone pipes
  imports: [FormatTimeAgoPipe, TimeZonePipe],
  declarations: [
    ...PIPES,
  ],
  exports: [
    FormatTimeAgoPipe,
    ...PIPES
  ]
})
export class PipesModule {}
